import { render, staticRenderFns } from "./candidate-qualifications.vue?vue&type=template&id=52deb3fd&scoped=true&"
import script from "./candidate-qualifications.vue?vue&type=script&lang=js&"
export * from "./candidate-qualifications.vue?vue&type=script&lang=js&"
import style0 from "./candidate-qualifications.vue?vue&type=style&index=0&id=52deb3fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52deb3fd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCard,VChip,VChipGroup,VCol,VIcon,VSimpleTable})
